import { createFileRoute } from "@tanstack/react-router";
import Trabajos from "../pages/Trabajos";

export const Route = createFileRoute("/trabajos")({
  head: () => ({
    meta: [
      { title: "Casos — Negocios reales funcionando hoy | CreceLocal" },
      {
        name: "description",
        content:
          "Los sitios web y sistemas que construimos para empresas de servicios y distribuidores. Casos reales, cuentas funcionando, con el testimonio del dueño.",
      },
      {
        property: "og:title",
        content: "Casos — Negocios reales funcionando hoy | CreceLocal",
      },
      {
        property: "og:description",
        content:
          "Los sitios web y sistemas que construimos para empresas de servicios y distribuidores. Casos reales, cuentas funcionando, con el testimonio del dueño.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: Trabajos,
});
